import { Button, FormControl, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material"
import Box from "@mui/material/Box"
import ChatMessage from "../admin-chat-client/ChatMessage"
import useChatClient from "../../hooks/useChatClient";
import { useAuth } from "../../../../hooks/useAuth";
import { useEffect, useRef, useState } from "react";


const AdminChatContent = () => {
    const { user } = useAuth();
    const [value, setValue] = useState('');
    const ref = useRef<HTMLDivElement>(null);

    const {
        selectedChat,
        sendMessageAsync,
        updateStatus        
    } = useChatClient();

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollTo(0, ref.current.scrollHeight + 200);
        }
    },[selectedChat])

    if (selectedChat == null || user == null) return <Box>No conversation selected.</Box>

    const handleChange = async (event: SelectChangeEvent) => {
        await updateStatus(event.target.value);        
    };

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key == 'Enter' || e.keyCode == 13) {
            sendMessage();
        }
    }

    const sendMessage = async () => {
        try {
            await sendMessageAsync(value);
         
            setValue('');
        } catch (err) {
            alert('Error sending message');
        }
    }

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <FormControl>
                    <Select
                        value={selectedChat.status}
                        onChange={handleChange}
                        size="small"
                    >
                        <MenuItem value='TicketOpen'>Open</MenuItem>
                        <MenuItem value='TicketClosed'>Closed</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div style={{ flex: 1, overflowY: 'scroll', position: 'relative', display: 'flex', flexDirection: 'column' }} ref={ref }>
                {selectedChat.messages.map(m => <ChatMessage message={m} userId={user.id} />)}                
            </div>
            <div style={{ margin: 20, display: 'flex', gap: 4 }}>
                <TextField fullWidth size="small" onChange={(e) => setValue(e.target.value)} value={value} onKeyUp={handleEnter} />
                <Button variant='contained'>Send</Button>
            </div>
        </>
    )
}

export default AdminChatContent;